import { ref } from 'vue'
import { createSharedComposable } from '@vueuse/core'

export default createSharedComposable(() => {
  const showModal = ref(false)

  const closeModal = () => {
    showModal.value = false
  }

  return {
    showModal,
    closeModal,
  }
})
